export const BOOKINGS_TABLE_SORTABLE_COLUMNS = [
    { sortKey: 'status', labelKey: 'bookings.columns.status' },
    { sortKey: 'timeslot', labelKey: 'bookings.columns.timeslot' },
    { sortKey: 'name', labelKey: 'bookings.columns.guest' },
];
